import * as React from 'react';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Date, DateField, Input, InputField } from '@components/form';

import * as T from '@modules/employees/_employeesTypes';

const enhance = compose<T.EmplyeesFormProps, T.Outter & T.EmplyeesFormProps>(
  reduxForm({
    form: 'module-employee-trainings'
  })
);

const View: React.SFC<T.Outter & T.EmplyeesFormProps> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Datum absolvování</h4>
              </Col>
              <Col md={8}>
                <DateField component={Date} name="absolved" />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Poznámka</h4>
              </Col>
              <Col md={8}>
                <InputField
                  component={Input}
                  multiLine={true}
                  name="note"
                  style={{ maxHeight: '60vh' }}
                  inputStyle={{ maxHeight: '60vh' }}
                  textareaStyle={{ maxHeight: '56vh' }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const EmployeesFormTrainingsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormTrainingsForm.tsx